import { render, staticRenderFns } from "./FaqsSectionModule.vue?vue&type=template&id=393b20e6&"
import script from "./FaqsSectionModule.vue?vue&type=script&lang=js&"
export * from "./FaqsSectionModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports